
import { useTranslation } from 'react-i18next';
import NoticeBoardListing from "../../../components/UserInfo/NoticeBoardListing";
import { NavLink } from 'react-router-dom';
const RecentNotices=(props:any)=>{
    const {t}=useTranslation();
    return <div className="px-5 py-4">
        <div className="flex justify-between items-center">
            <h3 className="heading4 font-bold text-darkblackv2 leading-[normal] mr-[10px]">{t('recent_notices')}</h3>
            <NavLink to={{pathname:"/profile/notice_board"}} className="inline-block text-button font-normal text-sat_darkgray underline underline-offset-2">
                {t('view_all')}
            </NavLink>
        </div>
        <NoticeBoardListing limit={2}/>
    </div>
}
export default RecentNotices;